import { Stack, Typography } from '@mui/material'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'

import { INTERAX_COLORS } from '../../../../../constants/colors'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../../interaxDesignSystemComponents'
import { resolveCoachStartCopy } from '../coachPageStyles'

type CoachEmptyStateProps = {
  onStart: () => void
  disabled: boolean
  /** No development goals yet: the first talk has one job, so the invitation names it. */
  isFirstGoalSetting: boolean
  /** A leadership talk has its own job, and it is not about their own game. */
  isLeadershipFocus: boolean
}

const EMPTY_TEXT_MAX_WIDTH_PX = 360

/** The only way into a conversation: arriving on the page writes nothing and says nothing. */
export const CoachEmptyState = ({ onStart, disabled, isFirstGoalSetting, isLeadershipFocus }: CoachEmptyStateProps) => {
  const { t } = useTranslation()

  // Naming the job beats a generic invitation: "start a conversation" says nothing about what it is for.
  const copy = resolveCoachStartCopy(t, { isFirstGoalSetting, isLeadershipFocus }) ?? {
    title: t('gamer.ariaCoach.sayHi'),
    body: t('gamer.ariaCoach.emptyBody'),
    cta: t('gamer.ariaCoach.startConversation')
  }

  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ flex: 1, minHeight: 0, py: 4 }}>
      <Typography sx={{ color: INTERAX_COLORS.white, fontWeight: 700, fontSize: 18 }}>{copy.title}</Typography>
      <Typography sx={{ color: INTERAX_COLORS.thunderGrey, textAlign: 'center', maxWidth: EMPTY_TEXT_MAX_WIDTH_PX }}>
        {copy.body}
      </Typography>
      <Button
        variant="primary"
        onClick={onStart}
        disabled={disabled}
        icon={<ChatBubbleLeftRightIcon width={18} />}
        iconPosition="left"
      >
        {copy.cta}
      </Button>
    </Stack>
  )
}
